import { filter } from 'rxjs/operators';
import { Component, OnInit, ViewChild, AfterViewInit, NgZone, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy, PopStateEvent } from '@angular/common';

import { NavbarComponent } from '../../components/navbar/navbar.component';
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import { Subscription, Observable, firstValueFrom } from 'rxjs';
import PerfectScrollbar from 'perfect-scrollbar';
import { Time } from 'app/shared/models/time';
import { PrivateService } from 'app/core/services/private.service';
import { DataStorageService } from 'app/core/services/data-storage.service';
import { Account } from 'app/shared/models/account';
import { VisibilityService } from 'app/core/services/visibility.service';
import { SessionMonitorService } from 'app/core/services/session-monitor.service';
import { BroadcastService } from 'app/core/services/broadcast.service';
import { PushNotificationService } from 'app/core/services/push-notification.service'; // Add this
import { TabService } from 'app/core/services/tab.service';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
    private _router: Subscription;
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];
    private notificationSubscription: Subscription;

    isSessionExpired: boolean = false;
    logLoading: boolean = false;
    // Hidden by default on mobile (off-canvas), visible by default on desktop.
    sidebarCollapsed = window.innerWidth <= 991;

    toggleSidebar(): void { this.sidebarCollapsed = !this.sidebarCollapsed; }
    initialData: any;
    accountInfo: Account;
    @ViewChild('alertComponent') alertComponent!: ElementRef;
    showAlert: boolean = false;

    broadcastMessages: any[] = [];
    currentMessageIndex: number = 0;
    showBroadcastPopup: boolean = false;
    isBroadcastMinimized: boolean = false;
    isLoading: boolean = false;

    constructor(
        public location: Location,
        private router: Router,
        private privateService: PrivateService,
        private ngZone: NgZone,
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private dataStorage: DataStorageService,
        private visibilityService: VisibilityService,
        private sessionMonitor: SessionMonitorService,
        private broadcastService: BroadcastService,
        private pushNotificationService: PushNotificationService, // Add this
        public tabService: TabService
    ) {
        this.visibilityService.isTabVisible$.subscribe((isVisible) => {
            if (isVisible) {
            } else {
            }
        });
    }

    ngOnInit() {
        this.showAlert = !!this.alertComponent;

        const supervisorMode = localStorage.getItem('account');
        if (supervisorMode) {
            this.accountInfo = JSON.parse(supervisorMode);
        }

        // Initialize push notifications
        // this.initializePushNotifications();

        this.updateTime();
        const isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        if (isWindows && !document.getElementsByTagName('body')[0].classList.contains('sidebar-mini')) {
            document.getElementsByTagName('body')[0].classList.add('perfect-scrollbar-on');
        } else {
            document.getElementsByTagName('body')[0].classList.remove('perfect-scrollbar-off');
        }
        const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

        this.location.subscribe((ev: PopStateEvent) => {
            this.lastPoppedUrl = ev.url;
        });
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart) {
                if (event.url != this.lastPoppedUrl)
                    this.yScrollStack.push(window.scrollY);
            } else if (event instanceof NavigationEnd) {
                if (event.url == this.lastPoppedUrl) {
                    this.lastPoppedUrl = undefined;
                    window.scrollTo(0, this.yScrollStack.pop());
                } else
                    window.scrollTo(0, 0);
            }
        });
        this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            elemMainPanel.scrollTop = 0;
            elemSidebar.scrollTop = 0;
            if (window.innerWidth <= 991) this.sidebarCollapsed = true;
        });
        const isTouchDevice = navigator.maxTouchPoints > 0 || ('ontouchstart' in window);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !isTouchDevice) {
            let ps = new PerfectScrollbar(elemMainPanel);
            ps = new PerfectScrollbar(elemSidebar);
        }
        this.initialData = this.dataStorage.getInitialData();
        this.loadBroadcastMessages();
    }

    ngOnDestroy() {
        // Clean up subscriptions and listeners
        if (this.notificationSubscription) {
            this.notificationSubscription.unsubscribe();
        }
        this.pushNotificationService.removeAllListeners();
    }

    /**
     * Initialize push notifications
     */
    async initializePushNotifications(): Promise<void> {
        try {
            await this.pushNotificationService.initializePushNotifications();

            // Subscribe to notification events
            this.notificationSubscription = this.pushNotificationService.notification$.subscribe(
                notification => {
                    if (notification) {
                        // Handle received notification
                        this.handlePushNotification(notification);
                    }
                }
            );

            // Subscribe to device token
            this.pushNotificationService.token$.subscribe(token => {
                if (token) {
                    console.log('Device token received:', token);
                    // You can save this token to your backend here
                    this.saveDeviceToken(token);
                }
            });
        } catch (error) {
            console.error('Failed to initialize push notifications:', error);
        }
    }

    /**
     * Handle incoming push notification
     */
    private handlePushNotification(notification: any): void {
        console.log('Push notification received in component:', notification);

        // You can show a custom alert or update UI here
        // For example, if it's a broadcast message:
        if (notification.data?.type === 'broadcast') {
            this.loadBroadcastMessages(); // Reload broadcast messages
        }

        // Or show a toast/snackbar notification
        // this.showNotificationAlert(notification.title, notification.body);
    }

    /**
     * Save device token to backend
     */
    private saveDeviceToken(token: string): void {
        // TODO: Implement your API call to save the device token
        // Example:
        // this.privateService.saveDeviceToken(token).subscribe(
        //   response => console.log('Token saved successfully'),
        //   error => console.error('Error saving token:', error)
        // );

        console.log('Saving device token to backend:', token);
    }

    ngAfterViewInit() {
        this.runOnRouteChange();
    }

    loadBroadcastMessages(): void {
        this.broadcastService.get_broadcast_message_for_user().subscribe(messages => {
            this.broadcastMessages = messages;
            if (messages.length > 0) {
                this.showBroadcastPopup = true;
            }
        });
    }

    toggleBroadcastPopup(): void {
        this.isBroadcastMinimized = !this.isBroadcastMinimized;
    }

    closeBroadcastPopup(): void {
        this.showBroadcastPopup = false;
    }

    nextMessage(): void {
        if (this.currentMessageIndex < this.broadcastMessages.length - 1) {
            this.currentMessageIndex++;
        }
    }

    previousMessage(): void {
        if (this.currentMessageIndex > 0) {
            this.currentMessageIndex--;
        }
    }

    goToMessage(index: number): void {
        this.currentMessageIndex = index;
    }

    confirmMessage(index: number): void {
        this.isLoading = true;
        if (this.broadcastMessages[index]) {
            this.broadcastMessages[index].confirmed = true;

            this.broadcastService.confirm_message(this.broadcastMessages[index].id).subscribe(
                response => {
                    this.isLoading = false;
                    console.log('Message confirmed successfully');
                },
                error => {
                    console.error('Error confirming message', error);
                    this.broadcastMessages[index].confirmed = false;
                    this.isLoading = false;
                }
            );

            const allConfirmed = this.broadcastMessages.every(msg => msg.confirmed);
            if (allConfirmed) {
                setTimeout(() => {
                    this.closeBroadcastPopup();
                }, 1500);
            }
        }
    }

    getTargetIcon(targetType: string): string {
        switch (targetType) {
            case 'Department':
                return 'person';
            case 'Branch':
                return 'person';
            case 'User':
                return 'person';
            default:
                return 'info';
        }
    }

    isOverdue(date: string | Date): boolean {
        if (!date) return false;
        const today = new Date();
        const due = new Date(date);
        due.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        return due < today;
    }

    isMaps(path) {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        titlee = titlee.slice(1);
        if (path == titlee) {
            return false;
        }
        else {
            return true;
        }
    }

    runOnRouteChange(): void {
        const isTouchDevice = navigator.maxTouchPoints > 0 || ('ontouchstart' in window);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !isTouchDevice) {
            const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
            const ps = new PerfectScrollbar(elemMainPanel);
            ps.update();
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    getApiTime(): Observable<Time> {
        return this.privateService.getApiTime();
    }

    async updateTime() {
        try {
            const data: Time = await firstValueFrom(this.getApiTime());
            this.ngZone.run(() => {
                this.cdr.markForCheck();
            });
        } catch (error) {
            this.isSessionExpired = true;
            console.error('Error fetching server time:', error);
        }
    }

    logout() {
        localStorage.removeItem('jwt');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('account');
        localStorage.removeItem('isPassConfirm');
        localStorage.removeItem('isPassConfirm_access');
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.includes('TableColumns')) {
                localStorage.removeItem(key);
                i--;
            }
        }
        window.location.href = '/#/login';
    }
}